import React from 'react';
import PropTypes from 'prop-types';
import { useImmer } from 'use-immer';
import _ from 'lodash';
import Button from '@components/@core/AnimatedButton';
import Select from '@components/@core/Select';
import { api } from '~/sagas';

const selectStyle = {
    control: (provided, state) => ({
        ...provided,
        border: 'none',
    }),
    indicatorSeparator: (provide, state) => ({
        display: 'none',
    }),
};

const defaultVendorStack = {
    DMS: {},
    CRM: {},
    Websites: {},
    Inventory: {},
    HCM: {},
    PPC: {},
    SEO: {},
};

const CompanyVendorCard = ({ venCategories, bio, onVendorChange, onNext }) => {
    const [vendorStack, updateVendorStack] = useImmer(defaultVendorStack);
    const { name, info, primary_phone, address, url, type } = bio;
    const disabled = !name;

    const handleSelectFocus = (vName, categoryId) => async () => {
        if (vendorStack[vName].products) return;

        try {
            updateVendorStack((draft) => {
                draft[vName].isLoading = true;
            });
            const res = await api.getCategoryProducts(categoryId, 'alphabetic=1&per_page=500');
            if (res.data?.data) {
                updateVendorStack((draft) => {
                    draft[vName].isLoading = false;
                    draft[vName].products = res.data.data;
                });
            }
        } catch (e) {
            console.error('>> Calling Vendor Product Error:', e);
        }
    };

    const handleDropdownChange = (shortName) => (selectedItem) => {
        if (!selectedItem) {
            onVendorChange(shortName, {});
        } else {
            const selectedProduct = vendorStack[shortName].products.find((product) => product.id === selectedItem.value);
            const payload = {
                company: _.pick(selectedProduct.parent, ['id', 'name', 'slug']),
                products: [_.pick(selectedProduct, ['id', 'name', 'slug'])],
            };
            updateVendorStack((draft) => {
                draft[shortName].value = payload;
            });
            onVendorChange(shortName, payload);
        }
    };

    return (
        <div className="card pb-3 mb-3 vdra-vendor">
            {type == '1' && (
                <>
                    <p className="dsl-b22 bold">Vendor Stack</p>

                    {venCategories.map((venCat, idx) => (
                        <div className="d-flex core-select py-2" key={idx}>
                            <span className="dsl-b12 me-2 core-select-label">{venCat.shortName}</span>

                            <Select
                                className="core-select-input"
                                isLoading={vendorStack[venCat.shortName] && vendorStack[venCat.shortName].isLoading}
                                itemLabel="name"
                                itemValue="id"
                                field
                                cacheOptions
                                isClearable
                                options={vendorStack[venCat.shortName].products || []}
                                loadingMessage={() => 'Loading'}
                                styles={selectStyle}
                                onChange={handleDropdownChange(venCat.shortName)}
                                onFocus={handleSelectFocus(venCat.shortName, venCat.id)}
                            />
                        </div>
                    ))}
                </>
            )}
            <div className="d-flex mt-3 jc-end">
                <Button name="NEXT" disabled={disabled} onClick={onNext} />
            </div>
        </div>
    );
};

CompanyVendorCard.propTypes = {
    venCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
    onNext: PropTypes.func,
    onDropdownChange: PropTypes.func,
};

CompanyVendorCard.defaultProps = {
    onNext: () => {},
    onDropdownChange: () => {},
};

export default CompanyVendorCard;
